import { useTranslation } from 'react-i18next';

function StockFooter() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center space-y-2.5">
      <button className="text-blue">{t('StockFooter.follow')}</button>
      <button className="text-white bg-blue rounded-full py-4 px-12 text-xl font-semibold">
        {t('StockFooter.watchAll')}
      </button>
      <p className="text-center text-gray leading-5">
        {t('StockFooter.desc')}
        <br />
        {t('StockFooter.desc2')}
      </p>
    </div>
  );
}

export default StockFooter;
